import { render, staticRenderFns } from "./IndividualsView.vue?vue&type=template&id=01293b8e&scoped=true&"
import script from "./IndividualsView.vue?vue&type=script&lang=js&"
export * from "./IndividualsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01293b8e",
  null
  
)

export default component.exports